import React from 'react';
import { Calendar, ClipboardCheck, Sparkles, ArrowRight } from 'lucide-react';
import { processSteps } from '../data/mock';

const iconMap = {
  Calendar,
  ClipboardCheck,
  Sparkles,
};

const ProcessSection = ({ onGetEstimate }) => {
  return (
    <section id="process" className="py-20 bg-[#0A0A0A]">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-[#7BA428] text-black px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Simple Process
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            How It Works
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Getting started is easy. No complicated processes, no hidden surprises.
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 relative">
            {/* Connecting Line (Desktop) */}
            <div className="hidden md:block absolute top-24 left-[16%] right-[16%] h-0.5 bg-[#2A2A2A] rounded-full" />

            {processSteps.map((step, index) => {
              const IconComponent = iconMap[step.icon];
              return (
                <div key={step.step} className="relative">
                  {/* Step Card */}
                  <div className="bg-[#141414] border border-[#2A2A2A] rounded-3xl p-8 text-center hover:border-[#7BA428]/50 transition-all duration-300 relative z-10">
                    {/* Step Number */}
                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 bg-[#7BA428] text-black rounded-full flex items-center justify-center font-bold text-sm">
                      {step.step}
                    </div>

                    {/* Icon */}
                    <div className="w-20 h-20 bg-[#7BA428] rounded-full flex items-center justify-center mx-auto mb-6 mt-4">
                      {IconComponent && <IconComponent className="w-10 h-10 text-black" />}
                    </div>

                    {/* Content */}
                    <h3 className="text-xl font-bold text-white mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed">
                      {step.description}
                    </p>
                  </div>

                  {/* Arrow (Mobile) */}
                  {index < processSteps.length - 1 && (
                    <div className="md:hidden flex justify-center my-4">
                      <ArrowRight className="w-6 h-6 text-[#2A2A2A] rotate-90" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <button
            onClick={onGetEstimate}
            className="bg-[#7BA428] text-black px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#B8E550] transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-[#7BA428]/20 inline-flex items-center gap-2"
          >
            Start Now – Get Free Estimate
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
